var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectPdfIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 120,
    viewBox: "0 0 121 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6501_24023)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.5 97.5H15.5C13.5115 97.4979 11.6051 96.7071 10.199 95.301C8.79293 93.8949 8.00208 91.9885 8 90V75H15.5V90H30.5V97.5Z",
    fill: "#ABDBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 45H8V60H15.5V45Z",
    fill: "#ABDBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98 30H90.5V15H75.5V7.5H90.5C92.4885 7.50208 94.3949 8.29293 95.801 9.699C97.2071 11.1051 97.9979 13.0115 98 15V30Z",
    fill: "#ABDBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5 7.5H45.5V15H60.5V7.5Z",
    fill: "#ABDBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 30H8V15C8.00208 13.0115 8.79293 11.1051 10.199 9.699C11.6051 8.29293 13.5115 7.50208 15.5 7.5H30.5V15H15.5V30Z",
    fill: "#ABDBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.75 120C101.257 120.001 100.77 119.904 100.315 119.715C99.8597 119.527 99.4465 119.25 99.0988 118.901L76.0824 95.8849L63.62 114.58C63.2252 115.172 62.67 115.64 62.0193 115.929C61.3686 116.217 60.6492 116.314 59.9452 116.209C59.2413 116.104 58.5818 115.8 58.0439 115.334C57.506 114.868 57.1118 114.258 56.9075 113.577L34.4075 38.5767C34.213 37.9281 34.1978 37.2391 34.3633 36.5826C34.5289 35.9261 34.8691 35.3266 35.3478 34.8479C35.8266 34.3691 36.426 34.0289 37.0825 33.8633C37.739 33.6978 38.4281 33.7131 39.0766 33.9075L114.077 56.4075C114.758 56.6119 115.368 57.006 115.834 57.5439C116.3 58.0818 116.604 58.7413 116.709 59.4453C116.814 60.1492 116.717 60.8686 116.429 61.5193C116.14 62.1701 115.672 62.7253 115.08 63.12L96.3849 75.5824L119.401 98.5988C119.75 98.9468 120.026 99.3601 120.215 99.8151C120.403 100.27 120.5 100.758 120.5 101.25C120.5 101.742 120.403 102.23 120.215 102.685C120.026 103.14 119.75 103.553 119.401 103.901L104.401 118.901C104.054 119.25 103.64 119.527 103.185 119.715C102.73 119.904 102.243 120.001 101.75 120ZM101.75 110.947L111.447 101.25L84.6163 74.4188L104.288 61.302L43.5939 43.0939L61.802 103.788L74.9188 84.1163L101.75 110.947Z",
    fill: "#ABDBFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6501_24023"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectPdfIcon);
export default __webpack_public_path__ + "static/media/select-pdf-icon.3b8f4f86b6a7b2f07e7802957c950463.svg";
export { ForwardRef as ReactComponent };